import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import * as R from 'ramda'

import { LabeledInput as UnstyledLabeledInput } from 'components/LabeledInput'
import { TEMP_ID_PREFIX, getAutoId } from 'organisms/SurveySettingsV2/constants'
import useFeatureToggle from 'hooks/useFeatureToggle'
import useSurveyChoiceOrder from 'hooks/useSurveyChoiceOrder'

const RATING_SENTIMENT = {
  1: 'negative',
  2: 'negative',
  3: 'neutral',
  4: 'positive',
  5: 'positive',
}

const SCALE_RATING = {
  2: [4, 2],
  3: [4, 3, 2],
  4: [5, 4, 3, 2],
  5: [5, 4, 3, 2, 1],
}

const EMOJI_RATING = {
  1: '😡',
  2: '😠',
  3: '😐',
  4: '😀',
  5: '😍',
}

export default function SentimentChoiceInput({ choices, scale, onChange }) {
  const { enableRatingChoiceOrder } = useFeatureToggle()
  const isReverseOrder = useSurveyChoiceOrder()
  const baseRatings = SCALE_RATING[scale] || []
  const ratings =
    enableRatingChoiceOrder && isReverseOrder ? [...baseRatings].reverse() : baseRatings
  return ratings.map((rating, index) => {
    const icon = EMOJI_RATING[rating]

    const choiceIndex = choices.findIndex((choice) => choice.value && choice.value == rating)
    const isOldChoice = choiceIndex > -1
    if (isOldChoice) {
      const choice = R.path([choiceIndex], choices)
      return (
        <LabeledInput
          className="choice-item"
          inputProps={{ maxLength: '250', required: true, 'data-testid': 'choice-input' }}
          key={index}
          label={icon}
          value={choice.label}
          onChange={(label) => onChange({ ...choice, label: label })}
        />
      )
    } else {
      const choice = {
        id: `${TEMP_ID_PREFIX}${getAutoId()}`,
        label: '',
        value: rating,
        sentiment: RATING_SENTIMENT[rating],
      }

      return (
        <LabeledInput
          className="choice-item"
          inputProps={{ maxLength: '250', required: true, 'data-testid': 'choice-input' }}
          key={index}
          label={icon}
          value={choice.label}
          onChange={(label) => onChange({ ...choice, label: label })}
        />
      )
    }
  })
}

SentimentChoiceInput.propTypes = {
  choices: PropTypes.arrayOf(PropTypes.string),
  scale: PropTypes.oneOf([2, 3, 4, 5]),
  onChange: PropTypes.func,
}

const LabeledInput = styled(UnstyledLabeledInput)`
  &:not(:first-child) {
    margin-top: 0.5em;
  }
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/SentimentChoiceInput/index.js